import { Dispatch, SetStateAction } from 'react';

import { Button, Modal, Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { WrapperBlock } from 'coreOld/elements';
import { Size } from 'coreOld/enums';
import { IManufacturer } from 'partsOld/types';

import { columns } from './columns';
import { MODAL_TITLE } from './constants';
import { TableWrapper } from './unkownManufacturerModalStyle';

interface IProps {
  onManufacturerChange: (value: IManufacturer, unknownManufacturer: string) => void;
  onOmitChange: (unknownManufacturer: string) => void;
  manufacturers: IManufacturer;
  omits: boolean;
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  onSave: () => void;
  unknownManufacturers: string[];
}

const UnkownManufacturerModalView = ({
  onManufacturerChange,
  onOmitChange,
  manufacturers,
  omits,
  isModalOpen,
  setIsModalOpen,
  onSave,
  unknownManufacturers,
}: IProps) => {
  return (
    <Modal
      title={MODAL_TITLE}
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      size={Size.LG}
    >
      <WrapperBlock>
        <TableWrapper>
          <Table
            columns={columns(manufacturers, omits, onManufacturerChange, onOmitChange)}
            data={unknownManufacturers}
            headerLines={2}
            name={TableNames.IMPORT_UNKOWN_MANUFACTURERS}
            hasFooter={true}
            isScrollable={false}
            alternating={false}
            borderBottom={true}
          />
        </TableWrapper>
      </WrapperBlock>

      <WrapperBlock hideBorderBottom buttonWrapper>
        <Button onClick={onSave}>Save</Button>
      </WrapperBlock>
    </Modal>
  );
};

export default UnkownManufacturerModalView;
